import "./contact-form-section.scss";
import React from "react";
import BackgroundGradient from "../BackgroundGradient";
import { useMove } from "hooks/useMove";
import ContactForm from "../ContactForm";
import useTranslation from "locales";

const ContactFormSection = ({ lang }) => {
  const { t } = useTranslation(lang);
  const { x, y, handleMouseMove } = useMove();
  return (
    <div
      className="contact-form-section"
      onMouseMove={handleMouseMove}
      aria-hidden="true"
    >
      <BackgroundGradient x={x} y={y} />
      <div className="contact-form-section__content">
        <h3
          className="contact-form-section__title white"
          dangerouslySetInnerHTML={{ __html: t("Zostaw <br /> wiadomość") }}
        />
        <ContactForm lang={lang} />
      </div>
    </div>
  );
};

export default ContactFormSection;
